export enum ServiceTypeEnum {
  TREATMENT = 'TREATMENT',
  MEDICAL_ASSESSMENT = 'MEDICAL_ASSESSMENT',
  ACCOMMODATION = 'ACCOMMODATION',
  REGULAR_FLIGHT_NON_MEDICAL = 'REGULAR_FLIGHT_NON_MEDICAL',
  REGULAR_FLIGHT_MEDICAL = 'REGULAR_FLIGHT_MEDICAL',
  AMBULANCE_FLIGHT = 'AMBULANCE_FLIGHT',
  GROUND_AMBULANCE = 'GROUND_AMBULANCE',
  GROUND_TRANSPORT = 'GROUND_TRANSPORT',
  MEDICAL_ESCORT = 'MEDICAL_ESCORT',
  HANDLING_OF_MORTAL_REMAINS = 'HANDLING_OF_MORTAL_REMAINS',
  AGENT = 'AGENT',
  MONEY_TRANSFER = 'MONEY_TRANSFER',
  LUGGAGE = 'LUGGAGE',
  REFERRAL_TO_CUSTOMER = 'REFERRAL_TO_CUSTOMER',
  ADVISE_ON_INSURANCE_TERMS = 'ADVISE_ON_INSURANCE_TERMS',
  GENERAL_ADVICE = 'GENERAL_ADVICE',
  OTHER_REFUND_REQUEST = 'OTHER_REFUND_REQUEST',
  ASSISTANCE_OR_CONTACT = 'ASSISTANCE_OR_CONTACT',
  ADVICE_CALL_REGISTRATION = 'ADVICE_CALL_REGISTRATION'
}

export enum ServiceTypeIconBackgroundColor {
  red,
  blue,
  green,
  purple,
  gray,
  lightGray,
  yellow
}
export class ServiceTypeEnumIcon {
  static getIcon(type: ServiceTypeEnum): string {
    switch (type) {
      case ServiceTypeEnum.TREATMENT:
        return 'serviceOrderTypes/Treatment.svg';
      case ServiceTypeEnum.MEDICAL_ASSESSMENT:
        return 'serviceOrderTypes/Medical Assessment.svg';
      case ServiceTypeEnum.ACCOMMODATION:
        return 'serviceOrderTypes/Accomodation.svg';
      case ServiceTypeEnum.REGULAR_FLIGHT_NON_MEDICAL:
        return 'serviceOrderTypes/Regular Flight - Non-medical.svg';
      case ServiceTypeEnum.REGULAR_FLIGHT_MEDICAL:
        return 'serviceOrderTypes/Regular Flight - Medical.svg';
      case ServiceTypeEnum.ASSISTANCE_OR_CONTACT:
        return 'serviceOrderTypes/Assistance or Contact.svg';
      case ServiceTypeEnum.AMBULANCE_FLIGHT:
        return 'serviceOrderTypes/Ambulance Flight.svg';
      case ServiceTypeEnum.GROUND_AMBULANCE:
        return 'serviceOrderTypes/Ambulance.svg';
      case ServiceTypeEnum.GROUND_TRANSPORT:
        return 'serviceOrderTypes/Ground Transport.svg';
      case ServiceTypeEnum.MEDICAL_ESCORT:
        return 'serviceOrderTypes/Medical Escort Fee.svg';
      case ServiceTypeEnum.HANDLING_OF_MORTAL_REMAINS:
        return 'serviceOrderTypes/Handling of mortal remains.svg';
      case ServiceTypeEnum.REFERRAL_TO_CUSTOMER:
        return 'serviceOrderTypes/Referral to Customer.svg';
      case ServiceTypeEnum.AGENT:
        return 'serviceOrderTypes/Agent.svg';
      case ServiceTypeEnum.LUGGAGE:
        return 'serviceOrderTypes/Luggage.svg';
      case ServiceTypeEnum.ADVISE_ON_INSURANCE_TERMS:
        return 'serviceOrderTypes/Advise on insurance terms.svg';
      case ServiceTypeEnum.GENERAL_ADVICE:
        return 'serviceOrderTypes/General Advice.svg';
      case ServiceTypeEnum.MONEY_TRANSFER:
        return 'serviceOrderTypes/Money Transfer.svg';
      case ServiceTypeEnum.OTHER_REFUND_REQUEST:
        return 'serviceOrderTypes/Other.svg';
      case ServiceTypeEnum.ADVICE_CALL_REGISTRATION:
        return 'serviceOrderTypes/Advice call registration.svg';
      default:
        return 'serviceOrderTypes/Other.svg';
    }
  }

  static getBackGroundColor(type: ServiceTypeEnum): string {
    const color = this.getBackGroundColorEnum(type);
    return this.getColorString(color);
  }

  static getBackGroundColorEnum(type: ServiceTypeEnum): ServiceTypeIconBackgroundColor {
    switch (type) {
      case ServiceTypeEnum.TREATMENT:
        return ServiceTypeIconBackgroundColor.red;
      case ServiceTypeEnum.MEDICAL_ASSESSMENT:
        return ServiceTypeIconBackgroundColor.red;
      case ServiceTypeEnum.ACCOMMODATION:
        return ServiceTypeIconBackgroundColor.green;
      case ServiceTypeEnum.REGULAR_FLIGHT_NON_MEDICAL:
        return ServiceTypeIconBackgroundColor.blue;
      case ServiceTypeEnum.REGULAR_FLIGHT_MEDICAL:
        return ServiceTypeIconBackgroundColor.blue;
      case ServiceTypeEnum.AMBULANCE_FLIGHT:
        return ServiceTypeIconBackgroundColor.blue;
      case ServiceTypeEnum.GROUND_AMBULANCE:
        return ServiceTypeIconBackgroundColor.blue;
      case ServiceTypeEnum.GROUND_TRANSPORT:
        return ServiceTypeIconBackgroundColor.blue;
      case ServiceTypeEnum.MEDICAL_ESCORT:
        return ServiceTypeIconBackgroundColor.red;
      case ServiceTypeEnum.HANDLING_OF_MORTAL_REMAINS:
        return ServiceTypeIconBackgroundColor.gray;
      case ServiceTypeEnum.ASSISTANCE_OR_CONTACT:
        return ServiceTypeIconBackgroundColor.purple;
      case ServiceTypeEnum.AGENT:
        return ServiceTypeIconBackgroundColor.purple;
      case ServiceTypeEnum.LUGGAGE:
        return ServiceTypeIconBackgroundColor.purple;
      case ServiceTypeEnum.REFERRAL_TO_CUSTOMER:
        return ServiceTypeIconBackgroundColor.purple;
      case ServiceTypeEnum.ADVISE_ON_INSURANCE_TERMS:
        return ServiceTypeIconBackgroundColor.purple;
      case ServiceTypeEnum.ADVICE_CALL_REGISTRATION:
        return ServiceTypeIconBackgroundColor.purple;
      case ServiceTypeEnum.GENERAL_ADVICE:
        return ServiceTypeIconBackgroundColor.purple;
      case ServiceTypeEnum.MONEY_TRANSFER:
        return ServiceTypeIconBackgroundColor.purple;
      case ServiceTypeEnum.OTHER_REFUND_REQUEST:
        return ServiceTypeIconBackgroundColor.yellow;
      default:
        return ServiceTypeIconBackgroundColor.gray;
    }
  }

  private static getColorString(color: ServiceTypeIconBackgroundColor): string {
    switch (color) {
      case ServiceTypeIconBackgroundColor.red:
        return '#F50A37';
      case ServiceTypeIconBackgroundColor.blue:
        return '#23AFDC';
      case ServiceTypeIconBackgroundColor.green:
        return '#34D1AA';
      case ServiceTypeIconBackgroundColor.purple:
        return '#905C9F';
      case ServiceTypeIconBackgroundColor.gray:
        return '#979DB1';
      default:
        // grey
        return '#979DB1';
    }
  }
}
